<mat-accordion [multi]="true">
  <mat-expansion-panel [expanded]="showRecentPanel"
                       class="mat-elevation-z0" hideToggle="true">
    <mat-expansion-panel-header (click)="showRecentPanel = !showRecentPanel;$event.stopPropagation()">
      <mat-panel-title>
        <mat-icon>{{showRecentPanel ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        <div class="col-md-9">
          Recents
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div  class="flex flex-row full-grow-no-shrink-no-basis ">
      <div class="pos-relative content full-grow-no-shrink-no-basis " >
        <div class="keno-grid-container">
          <particle-virtual-grid
            (selectionChanged)="onSelectionChanged($event)"
            (valueChanged)="onGridCellValueChange($event)"
            [api]="api"
            [invalidateSubject]="invalidateSubject"
            [isProjectSpecific]="false"
            [serviceName]="magicLinkModel.fieldValues['RecentFileServiceName']"
            [sourceKey]="magicLinkModel.fieldValues['RecentDirectoryEntrySourceKey']"
            sortDirection="dsc"
            sortFieldKey="ModifiedDate"
            tabStyle="none"
            version="v2">
          </particle-virtual-grid>
        </div>
      </div>

    </div>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="showStarredPanel"
                       class="mat-elevation-z0" hideToggle="true">
    <mat-expansion-panel-header (click)="showStarredPanel = !showStarredPanel;$event.stopPropagation()">
      <mat-panel-title>
        <mat-icon>{{showStarredPanel ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        <div class="col-md-9">
          Starred
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div  class="flex flex-row full-grow-no-shrink-no-basis ">
      <div class="pos-relative content full-grow-no-shrink-no-basis " >
        <div class="keno-grid-container">
          <particle-virtual-grid
            (selectionChanged)="onSelectionChanged($event)"
            (valueChanged)="onGridCellValueChange($event)"
            [api]="api"
            [invalidateSubject]="invalidateSubject"
            [isProjectSpecific]="false"
            [serviceName]="magicLinkModel.fieldValues['StarredFileServiceName']"
            [sourceKey]="magicLinkModel.fieldValues['StarredDirectoryEntrySourceKey']"
            sortDirection="dsc"
            sortFieldKey="ModifiedDate"
            tabStyle="none"
            version="v2">
          </particle-virtual-grid>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
